import { Validators } from "@angular/forms";
import { emailValidator } from "src/app/shared/custom-validators/email-Domain.validator";
import { FormMetaData } from "src/app/shared/structs/form-meta-data.struct";

export class VidaaSClientRequest {
    public email: string = undefined;
    public name: string = undefined;
    public comments: string = undefined;
    public redirect_uris: string[] = undefined;

    public static metadata(): Map<string, FormMetaData> {
        let metaData = new Map<string, FormMetaData>();
        metaData['email'] = new FormMetaData('VidaaS email', [Validators.required, Validators.email, emailValidator()]);
        return metaData;
    }
}